var path = 'src/app/patients/consents/consents.html';
var html = "<h1 class=page-header>Consents</h1> <div class=row> <div class=col-xs-12> <h4 class=extra-bottom-space> For more information concerning consent forms, please visit <a href=http://rarerenal.org/radar-registry/criteria-and-consent/ target=_blank>rarerenal.org website</a> </h4> </div> </div> <div patient-consents-component patient=patient></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/patients/consents/consents.html
 ** module id = 401
 ** module chunks = 0
 **/